import React, { useEffect } from 'react';
import classnames from 'classnames';
import './AcquisitionRasterCancelWarning.css';

const AcquisitionRasterCancelWarning = (props) => {
  const { rasterStatus, onCancel } = props;

  useEffect(() => {
    // Auto close the warning window if raster completes
    if (rasterStatus === 'completed') {
      onCancel();
    }
  }, [rasterStatus, onCancel]);

  return (
    <div id="AcquisitionRasterCancelWarning_Container" className="AcquisitionRasterCancelWarning_Container">
      <div id="AcquisitionRasterCancelWarning_TopContainer" className="AcquisitionRasterCancelWarning_TopContainer">
        <div id="AcquisitionRasterCancelWarning_HeaderText"  style={{color: '#ff5e00'}}className={'AcquisitionRasterCancelWarning_HeaderText'}>
          Warning - {props.title} Cancel
        </div>
        <div id="AcquisitionRasterCancelWarning_MessageText" className="AcquisitionRasterCancelWarning_MessageText">
          Exiting an {props.title} In Progress will require a minimum of 4 minutes to timeout.  Re-starting an {props.title} prior to the completion of the timeout will result in an error condition.
        </div>
      </div>
      <div
        id="AcquisitionRasterCancelWarning_BottomContainer"
        className="AcquisitionRasterCancelWarning_BottomContainer"
      >
        <button
          id="AcquisitionRasterCancelWarning_Bottom_CancelButton HeatmapDiagRasterWarningScreen_Bottom_CancelButton"
          className={classnames({
            AcquisitionRasterCancelWarning_Bottom_CancelButton: true
          })}
          onClick={() => {
            props.onCancel();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          id="AcquisitionRasterCancelWarning_Bottom_ActionButton "
          className={classnames({
            AcquisitionRasterCancelWarning_Bottom_ActionButton: true
          })}
          onClick={() => {
            props.onProceed();
          }}
        >
          Exit
        </button>
      </div>
    </div>
  );
};

export default React.memo(AcquisitionRasterCancelWarning);
